import { render, staticRenderFns } from "./UserGroupUsers.vue?vue&type=template&id=23c4c94b&scoped=true"
import script from "./UserGroupUsers.vue?vue&type=script&lang=js"
export * from "./UserGroupUsers.vue?vue&type=script&lang=js"
import style0 from "./UserGroupUsers.vue?vue&type=style&index=0&id=23c4c94b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c4c94b",
  null
  
)

export default component.exports